import { createContext, ReactNode, useEffect, useState } from 'react';

interface Props {
  children: ReactNode,
}

interface Context {
  bg: HTMLAudioElement,
  click: HTMLAudioElement,
  failed: HTMLAudioElement,
  scoreBoard: HTMLAudioElement,
  success: HTMLAudioElement,

  playClick: () => void,
  playFailed: () => void,
  playScoreBoard: () => void,
  playSuccess: () => void,
}

const DEFAULTCONTEXT: Context = {
  bg: new Audio(process.env.PUBLIC_URL + '/assets/media/bgm.mp3'),
  click: new Audio(process.env.PUBLIC_URL + '/assets/media/click.mp3'),
  failed: new Audio(process.env.PUBLIC_URL + '/assets/media/failed.mp3'),
  scoreBoard: new Audio(process.env.PUBLIC_URL + '/assets/media/score-board.mp3'),
  success: new Audio(process.env.PUBLIC_URL + '/assets/media/success.mp3'),

  playClick: function() { console.log('playClick'); try { (DEFAULTCONTEXT.click).play().then(() => { }); } catch (e) { console.warn(e) } },
  playFailed: function() { console.log('playFailed'); try { (DEFAULTCONTEXT.failed).play().then(() => { }); } catch (e) { console.warn(e) } },
  playScoreBoard: function() { console.log('playScoreBoard'); try { (DEFAULTCONTEXT.scoreBoard).play().then(() => { }); } catch (e) { console.warn(e) } },
  playSuccess: function() { console.log('playSuccess'); try { (DEFAULTCONTEXT.success).play().then(() => { }); } catch (e) { console.warn(e) } },
};

export const AudioContext = createContext<Context>(DEFAULTCONTEXT);

let started = false;

export default function AudioProvider(props: Props) {
  const [value] = useState<Context>(DEFAULTCONTEXT);

  useEffect(() => {
    // console.log(`AudioProvider`, value);
    value.bg.loop = true;
    value.bg.play().then(() => { })

    const tryStartBgMusic = () => {
      if (!started) {
        value.bg.play().then(() => { started = true });
      }
    }
    document.addEventListener('touchstart', tryStartBgMusic)
    document.addEventListener('mousedown', tryStartBgMusic)
    document.addEventListener('click', tryStartBgMusic)
    document.addEventListener('keydown', tryStartBgMusic)

    return () => {

    }
  }, [value.bg]);

  return (
    <AudioContext.Provider value={value}>
      {props.children}
    </AudioContext.Provider>
  )
}
